import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8a217b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scene-dailog" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "dailog-content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "status-text1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 切换至 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 场景 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("切换中...")
const _hoisted_9 = {
  key: 1,
  class: "status-text2"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("我知道了")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_buttons = _resolveComponent("buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.secenaroStatus.localName), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.parseImgUrl('ipdImages', 'taolun-big.svg')
      }, null, 8, _hoisted_4),
      _createElementVNode("span", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("i", null, _toDisplayString(_ctx.secenaroStatus.sceneName), 1),
        _hoisted_7
      ]),
      (_ctx.secenaroStatus.loading)
        ? (_openBlock(), _createBlock(_component_van_loading, {
            key: 0,
            class: "status-text2"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.secenaroStatus.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
            (_ctx.secenaroStatus.lodingText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " 已为您切换至适宜" + _toDisplayString(_ctx.secenaroStatus.sceneName) + "的环境", 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_buttons, {
      class: "dailog-btn",
      onClick: _ctx.closeDailog
    }, {
      default: _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}